<template>
    <div class="index">
        <!-- 头部区域 -->
        <div class="hd">
            <div class="conetnt_row">
                <!-- logo模块 -->
                <div class="logo">
                    <img src="../assets/logo-long.png" alt="">
                </div>
                <!-- 顶部搜索模块 -->
                <div class="hd-nav">
                    <div @click="toPath('index')">首页</div>
                    <div @click="toPath('about')">关于我们</div>
                    <div @click="toPath('solution')">解决方案</div>
                    <div @click="toPath('service')">产品服务</div>
                    <div @click="toPath('success')">成功案例</div>
                    <div @click="toPath('news')">新闻资讯</div>
                </div>
                <!-- 联系方式模块 -->
                <div class="call">
                    <p>咨询热线</p>
                    <h6>156 5717 7655</h6>
                </div>

            </div>
        </div>
        <div class="add_content" @click="toApply">申请试用</div>
        <el-dialog title="申请试用" :visible.sync="dialogShow" width="600px" @close="handleCancel">
            <el-form label-width="100px" class="demo-ruleForm" :rules="rules" ref="subData" :model="subData">
                <el-form-item label="公司名称" prop="company_name">
                    <el-input v-model="subData.company_name" placeholder="请输入公司名称"></el-input>
                </el-form-item>
                <el-form-item label="公司地址" prop="company_address">
                    <el-input v-model="subData.company_address" placeholder="请输入公司地址"></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="linker_name">
                    <el-input v-model="subData.linker_name" placeholder="请输入联系人"></el-input>
                </el-form-item>
                <el-form-item label="联系方式" prop="linker_mobile">
                    <el-input v-model="subData.linker_mobile" placeholder="请输入联系方式"></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align: right">
                <el-button @click="handleCancel">取 消</el-button>
                <el-button type="success" @click="handleSubmit(subData)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            rules: {
                company_name: [{ required: true, message: "请输入公司名称", trigger: ["blur", "change"] }],
                company_address: [{ required: true, message: "请输入公司地址", trigger: ["blur", "change"] }],
                linker_name: [{ required: true, message: "请输入联系人", trigger: ["blur", "change"] }],
                linker_mobile: [{ required: true, message: "请输入联系方式", trigger: ["blur", "change"] }],
            },
            dialogShow: false,
            subData: {
                company_name: "",
                company_address: "",
                linker_name: "",
                linker_mobile: ""
            },
            pathIndex: '1'
        }
    },
    created() { },
    mounted() {

    },
    methods: {
        toPath(e, index) {
            this.pathIndex = index;
            // console.log(this.path);

            this.$router.push('/' + e)
        },
        toApply() {
            this.dialogShow = true
        },
        handleCancel() {
            this.subData = {
                company_name: "",
                company_address: "",
                linker_name: "",
                linker_mobile: ""
            }
            this.$nextTick(() => {
                this.$refs['subData'].clearValidate(); //重置弹窗内容
            });
            this.dialogShow = false;
        },
        // async handleSubmit(subData) {
        //     this.$refs['subData'].validate((valid) => {
        //         if (valid) {
        //             // 调用 axios 的 get 方法，请求列表数据
        //             const { data: res } = await this.$https.post('/crm/apply-try/add', this.subData)
        //             console.log(res);
        //             // 只要请求回来的数据，在页面渲染期间要用到，则必须转存到 data 中
        //             if (res.resultCode == 1) {
        //                 this.$message.success(res.message);
        //                 console.log(res);
        //             } else {
        //                 console.log(res);
        //                 this.$message.error(res.message);
        //             }
        //         } else {
        //             return false;
        //         }
        //     });
        // },
        async handleSubmit(subData) {
            try {
                // 1️⃣ 使用 await 等待表单校验
                const valid = await this.$refs.subData.validate();
                if (!valid) return; // 校验失败则直接返回
                // 2️⃣ 校验通过后发送请求
                const { data: res } = await this.$https.post('/crm/apply-try/add', this.subData);
                if (res.resultCode === 1) {
                    this.$message.success(res.message);
                    this.dialogShow = false;
                } else {
                    this.$message.error(res.message);
                }
            } catch (error) {
                this.$message.error('请求发生错误');
            }
        }
    },
}
</script>

<style lang="less" scoped>
// .index {

// }

.content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.hd {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: .8333rem;
    background-color: #fff;
    box-shadow: 0px 0px .2604rem 0px rgba(0, 0, 0, 0.1);
    z-index: 2;
    padding: 0 4.25rem;
    box-sizing: border-box;
    // display: flex;
    // align-items: center;

}

.conetnt_row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    overflow: hidden;
}

.logo {

    box-sizing: border-box;
    display: flex;
    justify-content: center;
}

.logo img {
    width: 1.8417rem;
    height: 0.5167rem;
}


.hd-nav {
    height: .2708rem;
    margin-left: 1.0417rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.hd-nav>div {
    margin-right: .4167rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    display: flex;
    justify-content: center;
    align-items: center;
}


.hd-nav>div:hover {
    font-weight: 500;
    color: #08C667;
    border-bottom: .0208rem solid #08C667;
    cursor: pointer;
}

.call {
    position: relative;
    float: right;
    width: 1.7813rem;
    height: .5521rem;
}

.call p {
    position: absolute;
    top: 0;
    right: 0;
    height: .2292rem;
    font-size: .1667rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60646B;
    line-height: .2292rem;
}

.call h6 {
    position: absolute;
    right: 0;
    top: .2292rem;
    height: .3021rem;
    font-size: .2188rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #232A24;
    line-height: .3021rem;
}

.add_content {
    position: absolute;
    right: 0;
    top: 0;
    width: 1.6rem;
    height: .563rem;
    background-color: #08C667 !important;
    z-index: 999999;
    margin-top: .1354rem;
    margin-right: .24rem;
    border-radius: .051rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: .2083rem;
    font-weight: 600;
}

// .active {
//     color: #08C667 !important;
//     border-bottom: .0208rem solid #08C667 !important;
// }</style>